import { useTranslation } from "react-i18next";
import { Links as LinksFeature } from "@/partner/features/links";
import { Meta } from "@/shared/components";

export function LinksPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("links.pageTitle")} pageType="Partner" />
      <LinksFeature />
    </>
  );
}
